import * as actionTypes from './actionTypes'
import { fromJS } from 'immutable'

const defaultState = fromJS({
    //msg: 'activity',
})



export default (state = defaultState, action) => {

    switch (action.type) {


        case actionTypes.SET_ACTIVITY_DATA:
            return state.set("activity",action.data)
        case actionTypes.SET_ACTIVITY_SELECT_DATA:
            return state.set("activitySelect",action.data)

        default:
            return state;
    }
}
